import { render } from "./AudioPlayer.vue?vue&type=template&id=8c7373f6&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=8c7373f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8c7373f6"

export default script